type Props = {
  companyId: string;
  updateId?: string | null | undefined;
};

export const NarrativeUpdateEdit = ({ companyId, updateId }: Props) => {
  return (
    <div className="text-lg text-solid">
      Update page TODO {companyId} {updateId}
    </div>
  );
};
